console.clear();
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-format/dist/d3-format.min"),
  ...require("d3-geo/dist/d3-geo.min")
};

var noUiSlider = require("./lib/nouislider.min.js");

var onWindowLoaded = function() {

  // renderMap();

  var affectedData = window.DATA;
  var formatComma = d3.format(",");

  function formatRound(val) {
    return formatComma(Math.round(val/1000)*1000);

  }

  //make scale
  var keyContainer = d3.select("div.keyContainer");
  var breaks = window.BREAKS;

  var keyBlocks = keyContainer.selectAll(".breaks")
                .data(breaks)
                .enter()
                .append("div")
                .attr("class", "key-block");

  keyBlocks.append("div")
              .attr("class", "key-break")
              .style("background-color", d=> `rgb${d.color}`);

  keyBlocks.append("h3")
              .text(d=>d.depth);

  //add images
  var container = d3.select("div.surge-animation");

  var years = d3.range(2020,2110,30);
  var first = years[0];

  //set year to first
  var yearElement = d3.select("span.year");
  yearElement.html(first);

  //set affected to first
  var affectedElement = d3.select("span.affected");
  affectedElement.html(formatRound(affectedData[0].Int));

  var frames = container.selectAll(".frame")
            .data(years)
            .enter()
            .append("img")
            .attr("class", d=> d)
            .classed("visible", d => (d == first))
            .attr("src", d=>`surge/dc_Int_${d}.png`);

  // make slider
  var slider = document.getElementById('slider');

  noUiSlider.create(slider, {
      start: [2020],
      step: 30,
      range: {
          'min': 2020,
          'max': 2080
      }
        //   pips: {
    //      mode: 'steps',
    //      filter: function ( value, type ) {
    //       return (years.indexOf(value) != -1) ? 0 : -1;
    // }
  });

  var userInteracted = false; //check whether user has interacted
  var hasStarted = false;

  //event handling
  slider.noUiSlider.on("update", function(){
    console.log("update fired");
    var val = slider.noUiSlider.get(true);
    var current = Number(yearElement.html());
    if(val != current) {
      yearElement.html(val);
      var numAffected = affectedData.filter(e=>e.year==val)[0].Int;
      affectedElement.html(formatRound(numAffected));
      frames.classed("visible", d => (d == val))
    }

  })

  slider.noUiSlider.on("slide", function(){
      console.log("user interacted");
      userInteracted = true;
  })

  //above fires once on creation, so reset userInteracted to false
  userInteracted = false;

  function animateFrames(year){
    //if slider is used stop animation
    if(userInteracted) return;

    //otherwise loop through
    slider.noUiSlider.set(year);

    //get refererence to next frame
    var i = years.indexOf(year); //current index
    if(i<years.length-1){
      i++;
    } else {
      i = 0;
    }

    setTimeout(function(){
      animateFrames(years[i]);
    },1500);


  }


  //start looping through frames once graphic is visible
  var observer = new IntersectionObserver(intersectionCallback, {threshold: 0.25});
  var target = document.querySelector(".target");
  observer.observe(target);
  
  function intersectionCallback(entries, observer){
    entries.forEach(entry=> {
      if(entry.isIntersecting){
        //only start animation once
        if(hasStarted) return;
        console.log("start animation!")
        animateFrames(years[1]);
        hasStarted = true;
      }
    })
  }

  pym.then(child => {
      child.sendHeight();

      // child.onMessage("on-screen", function(bucket) {
      //     ANALYTICS.trackEvent("on-screen", bucket);
      // });
      // child.onMessage("scroll-depth", function(data) {
      //     data = JSON.parse(data);
      //     ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      // });

      window.addEventListener("resize", function(){

        child.sendHeight();

      });
  });
}

  // function renderMap(){

  //   console.log("render map!");
  //   //add vectors
  //   var vectorSvg = d3.select(".vector svg");
  //   vectorSvg.html("");

  //   var computedDimensions = vectorSvg.node().getBoundingClientRect();
  //   var w = computedDimensions.width;
  //   var h = computedDimensions.height;

  //   const centerLocation = {
  //         "longitude": -73.8720703,
  //         "latitude": 40.7534093
  //   };

  //   var albersNyc = d3.geoConicEqualArea()
  //                         .parallels([40.398554,41.1082645]) 
  //                         .rotate([centerLocation["longitude"]*-1,0,0])
  //                         .center([0,centerLocation["latitude"]])
  //                         .fitExtent([[0,0],[w,h]], box);

  //   var path = d3.geoPath().projection(albersNyc);

  //   var developments = vectorSvg.selectAll(".nycha")
  //                                 .data(nycha.features)
  //                                 .enter()
  //                                 .append("path")
  //                                 .attr("d", path)
  //                                   .attr("fill", "none")
  //                                   .attr("stroke", "#fff")
  //                                   .attr("stroke-width", 0.5);
  // }

// wait for images to load
window.onload = onWindowLoaded;
